import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { objectAppend } from 'scaleflow/utils/obj-append';

export default class GoalsTableIndexComponent extends Component {
  @service intl;

  @tracked showDeleteModal = false;
  @tracked selectedGoal = null;

  get columns() {
    if (this.args?.columns) return this.args?.columns;
    return [
      {
        name: this.intl.t('_goals.table.title'),
        valuePath: 'title',
        class: '!w-[80%]',
        key: 'title',
      },
      {
        name: '',
        valuePath: 'edit',
        class: '!w-[10%]',
        key: 'edit',
        component: 'link',
        type: 'primary',
        test_id: 'edit-goal',
      },
      {
        name: '',
        valuePath: 'delete',
        class: '!w-[10%]',
        key: 'delete',
        component: 'button',
        type: 'danger',
        test_id: 'delete',
      },
    ];
  }

  get rows() {
    if (this.args?.rows) return this.args?.rows;
    const goals = this.args?.goals.map((item) =>
      objectAppend(
        {
          title: item.title,
          edit: {
            label: this.intl.t('_goals.table.edit'),
            route: 'business.goals.goal.edit',
            model: item,
          },
          delete: {
            label: this.intl.t('_goals.table.delete'),
            onClick: () => this.handleDeleteGoal(item),
          },
        },
        { model: item },
      ),
    );
    return goals;
  }

  @action
  unselectGoal() {
    this.selectedGoal = null;
  }

  @action
  handleDeleteGoal(item) {
    this.selectedGoal = item;
    this.toggleDeleteModal(true);
  }

  @action
  toggleDeleteModal(flag) {
    if (flag === undefined) this.showDeleteModal = !this.showDeleteModal;
    else this.showDeleteModal = flag;
  }

  @action
  deleteGoal() {
    this.selectedGoal?.destroyRecord?.();
    this.unselectGoal();
  }

  @action
  handleDismissDeleteModal() {
    this.unselectGoal();
    this.toggleDeleteModal(false);
  }
}
